<template>
  <section
    class="zone-card zone-card-tight"
    data-testid="mcp-connected-apps"
  >
    <div
      v-if="!apps.length"
      class="zone-empty"
      data-testid="mcp-connected-apps-empty"
    >
      <div class="zone-empty-inner">
        <div class="zone-empty-illo">
          <div class="zone-empty-illo-inner">
            <McpEmptyIllustration />
          </div>
        </div>
        <div class="zone-empty-text">
          <b>No AI connected to MCP</b>
          <p>You still didn’t connect any AI app.<br>After you connect they will appear here.</p>
        </div>
      </div>
    </div>

    <div
      v-else
      class="zone-table-wrap"
    >
      <table class="zone-table">
        <colgroup>
          <col class="c-name">
          <col class="c-type">
          <col class="c-date">
          <col class="c-date">
          <col class="c-status">
        </colgroup>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Date added</th>
            <th>Last connected</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="app in apps"
            :key="app.client_name"
          >
            <td class="is-name">
              <span class="app-name">
                <McpAppLogo :name="app.logo" />
                {{ app.name }}
              </span>
            </td>
            <td>{{ app.type }}</td>
            <td>{{ app.connected_at }}</td>
            <td>{{ app.last_seen_at }}</td>
            <td><span class="zone-pill">Connected</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import McpAppLogo from '~/components/hubstaff_mcp/McpAppLogo.vue';
import McpEmptyIllustration from '~/components/hubstaff_mcp/McpEmptyIllustration.vue';

export default {
  name: 'McpConnectedApps',
  components: { McpAppLogo, McpEmptyIllustration },
  props: {
    apps: { type: Array, required: true },
  },
};
</script>

<style scoped>
.zone-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: #fff;
  border: 1px solid var(--gray-200);
  border-radius: var(--rounded-lg);
}

.zone-empty {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.zone-empty-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 290px;
}

.zone-empty-illo {
  display: flex;
  width: 98px;
  height: 94px;
  padding: 10px;
}

.zone-empty-illo-inner {
  position: relative;
  width: 78px;
  height: 74px;
}

.zone-empty-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  text-align: center;
  word-break: break-word;
}

.zone-empty-text b {
  color: var(--gray-900);
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
}

.zone-empty-text p {
  margin: 0;
  color: var(--gray-600);
  font-size: 14px;
  line-height: 20px;
}

.zone-table-wrap {
  min-width: 320px;
  border: 1px solid var(--gray-200);
  border-radius: var(--rounded-lg);
  overflow: hidden;
}

.zone-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.zone-table th,
.zone-table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--gray-200);
  border-right: 1px solid var(--gray-200);
  text-align: left;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zone-table th:last-child,
.zone-table td:last-child {
  border-right: 0;
}

.zone-table tbody tr:last-child td {
  border-bottom: 0;
}

.zone-table th {
  background: var(--gray-50);
  color: var(--gray-800);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.zone-table td {
  background: #fff;
  color: var(--gray-700);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.zone-table td.is-name {
  font-weight: 500;
  color: var(--gray-900);
}

.zone-table col.c-name {
  width: 28%;
}

.zone-table col.c-type {
  width: 14%;
}

.zone-table col.c-date {
  width: 21%;
}

.zone-table col.c-status {
  width: 16%;
}

.app-name {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.zone-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 999px;
  background: var(--green-100);
  color: var(--green-800);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
</style>
